import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import {
  Box,
  Column,
  FormField,
  InputSelectField,
  InputTextField,
  Radio,
  RadioGroup,
  Typography,
} from '@tempmee/react';
import { CollapsibleCard } from '../../../../commonComponents';
import { useFormContext } from '../../hooks/useFormContext';
import { formatCurrencyDisplay, parseCurrencyInput } from '../../utils';
import { CardTitle } from '../CardTitle';
import { useParking } from './hooks/useParking/useParking';

const opacityVariants = {
  show: { opacity: 1 },
  hide: { opacity: 0 },
};

export const ParkingCard = ({ isOpen, onToggle }) => {
  const { setValue, control } = useFormContext();
  const { formValues, isValid } = useParking(control);
  const allMetadata = useSelector((state) => state.user.allMetadata);

  return (
    <CollapsibleCard
      TitleComponent={() => <CardTitle name="Parking" showWarningIcon={!isOpen && !isValid} />}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <Column gap={5} px={20} style={{ marginBottom: 40 }}>
        {/* Free parking */}
        <FormField label="Parking:" required>
          <Typography color="#697A82" style={{ marginBottom: 16 }}>
            Free parking is available on site.
          </Typography>

          <RadioGroup
            value={formValues.isParkingFree === true ? 'yes' : formValues.isParkingFree === false ? 'no' : ''}
            onChange={(val) => setValue('isParkingFree', val === 'yes')}
            orientation="vertical"
          >
            <Radio value="yes" label="Yes" />
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <Radio value="no" label="No" />

              <motion.div
                animate={formValues.isParkingFree === false ? 'show' : 'hide'}
                variants={opacityVariants}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Box
                  style={{
                    display: 'grid',
                    alignItems: 'center',
                    gridTemplateColumns: '1.05fr 2fr 2fr',
                    maxWidth: '100%',
                    gridColumnGap: 12,
                    boxSizing: 'border-box',
                  }}
                >
                  <Typography bold size="body_large">
                    Parking Cost:
                  </Typography>

                  <InputTextField
                    value={formatCurrencyDisplay(formValues.parkingCost)}
                    placeholder="US$ --,--"
                    onChange={(e) => {
                      const parsed = parseCurrencyInput(e.target.value);
                      if (parsed !== null) setValue('parkingCost', parsed);
                    }}
                  />

                  <InputSelectField
                    value={formValues.parkingCostType}
                    onChange={(value) => setValue('parkingCostType', value)}
                    options={[
                      { label: 'per hour', value: 'hr' },
                      { label: 'per day', value: 'day' },
                    ]}
                  />
                </Box>
              </motion.div>
            </div>
          </RadioGroup>
        </FormField>

        {/* Parking type */}
        <FormField label="Parking Type:" required>
          <InputSelectField
            value={formValues.parkingType}
            onChange={(value) => setValue('parkingType', value)}
            options={
              allMetadata?.parkingTypes?.map((item) => ({ label: item, value: item })) ?? []
            }
          />
        </FormField>
      </Column>
    </CollapsibleCard>
  );
};
